import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-brands_page_sign_in-click';

/**
 * Track click events on sign in button. Parameter indicates the position of the button. Should be one of &quot;sticky-banner&quot; and &quot;top-section&quot;
 */
export function trackBrandLeadsBrandsPageSignInClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
